import * as React from "react";
const SvgFiRrMaskCarnival = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#062147" clipPath="url(#fi-rr-mask-carnival_svg__a)">
      <path d="M22.514 10.972a3.82 3.82 0 0 0-3.028-.944c-2.187.264-4.345.73-6.447 1.39C13.359 8.913 15.75 8 18 8a3 3 0 1 0 0-6 6.97 6.97 0 0 0-5 2.111V1a1 1 0 1 0-2 0v3.11A6.98 6.98 0 0 0 6 2a3 3 0 0 0 0 6c2.25 0 4.641.913 4.961 3.418a36 36 0 0 0-6.447-1.39 3.83 3.83 0 0 0-3.028.944 4.53 4.53 0 0 0-1.469 3.4C.017 23.062 4.852 24 6.931 24a5.38 5.38 0 0 0 3.09-1.185c.56-.474 1.25-.77 1.979-.848.73.078 1.42.374 1.979.848A5.4 5.4 0 0 0 17.069 24c2.079 0 6.914-.938 6.914-9.625a4.53 4.53 0 0 0-1.469-3.403M18 4a1 1 0 1 1 0 2 7.9 7.9 0 0 0-4.732 1.386A5.01 5.01 0 0 1 18 4M6 6a1 1 0 0 1 0-2 5.01 5.01 0 0 1 4.733 3.386A7.9 7.9 0 0 0 6 6m11.069 16a3.67 3.67 0 0 1-1.979-.848A5.4 5.4 0 0 0 12 19.967a5.4 5.4 0 0 0-3.09 1.185c-.56.474-1.25.77-1.979.848-3.169 0-4.914-2.708-4.914-7.625a2.57 2.57 0 0 1 .8-1.907 1.8 1.8 0 0 1 1.462-.453c2.51.295 4.978.883 7.352 1.75a1 1 0 0 0 .744 0 32.3 32.3 0 0 1 7.352-1.75 1.8 1.8 0 0 1 1.462.453 2.56 2.56 0 0 1 .8 1.907C21.983 19.292 20.238 22 17.069 22" />
      <path d="M17.83 15.023C15.309 15.6 12 16.648 12 16.648c2.009.213 4.056 2.051 5.114 2.345 1.109.308 1.527-.844 1.867-2.725a1.02 1.02 0 0 0-1.151-1.245M5.019 16.268c.34 1.881.758 3.033 1.867 2.725 1.058-.294 3.1-2.132 5.114-2.345 0 0-3.309-1.052-5.83-1.625a1.02 1.02 0 0 0-1.151 1.245" />
    </g>
    <defs>
      <clipPath id="fi-rr-mask-carnival_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMaskCarnival;
